/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module NvigoutilTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface NvIgoUtil {
    [k: string]: any;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "ToggleIGOParameters".
 */
export interface ToggleIGOParameters {
    /**
     * Enable/Disable In-game overlay.
     */
    toggle: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "GetShadowPlaySupportedParameters".
 */
export interface GetShadowPlaySupportedParameters {
    /**
     * System language.
     */
    language: string;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "GetShadowPlaySupportedReturn".
 */
export interface GetShadowPlaySupportedReturn {
    /**
     * Media pack information, WindowsN version does not have this pack installed by default.
     */
    MediaPack?: boolean;
    /**
     * GPU architecture check (Pascal+ required).
     */
    GPUSupported?: boolean;
    /**
     * Driver version check (531.61+ required).
     */
    DriverVersionSupported?: boolean;
    /**
     * OS version check (Windows 10+ required).
     */
    OSSupported?: boolean;
    /**
     * RAM check (4GB+ required).
     */
    RAMSupported?: boolean;
    /**
     * Overall ShadowPlay support (true if all system requirements pass).
     */
    ShadowPlaySupported?: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "GetShadowPlayStatusReturn".
 */
export interface GetShadowPlayStatusReturn {
    shadowPlayStatus?: ShadowPlayStatus;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "GetFilterPhotoModeStateReturn".
 */
export interface GetFilterPhotoModeStateReturn {
    /**
     * Filter & Photo mode state.
     */
    enable?: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "SetFilterPhotoModeParameters".
 */
export interface SetFilterPhotoModeParameters {
    /**
     * Enable/Disable Filter & PhotoMode
     */
    enable: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "SetGAssistInstallParameters".
 */
export interface SetGAssistInstallParameters {
    /**
     * True - GAssist installed, false - GAssist uninstalled
     */
    installed: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "OpenIGOParameters".
 */
export interface OpenIGOParameters {
    /**
     * Open IGO Main menu(false) or Settings page(true).
     */
    openSettings: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "GetHotkeyShortcutParameters".
 */
export interface GetHotkeyShortcutParameters {
    hotkey: HotkeyEnum;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "GetHotkeyShortcutReturn".
 */
export interface GetHotkeyShortcutReturn {
    /**
     * Array of integer values for the keys
     */
    keys?: number[];
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "SetNvAppReadyForGAssistReturn".
 */
export interface SetNvAppReadyForGAssistReturn {
    /**
     * True if event was created/set successfully
     */
    status: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "ToggleMcpServerParameters".
 */
export interface ToggleMcpServerParameters {
    /**
     * Enable/Disable MCP server for AI agents.
     */
    enable: boolean;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "GetMcpServerStatusReturn".
 */
export interface GetMcpServerStatusReturn {
    /**
     * True if the MCP server is running and ready (readiness event signaled)
     */
    enabled: boolean;
    accessLevel: AccessLevel;
}
/**
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "SetMcpServerAccessLevelParameters".
 */
export interface SetMcpServerAccessLevelParameters {
    accessLevel: AccessLevel;
}

/**
 * MCP server access level (readonly = safe tools only, standard = safe + normal, full_access = all tools)
 *
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "AccessLevel".
 */
export enum AccessLevel {
    readonly = 'readonly',
    standard = 'standard',
    full_access = 'full_access'
}
/**
 * Enum of possible Share-specific hotkey actions
 *
 * This interface was referenced by `NvIgoUtil`'s JSON-Schema
 * via the `definition` "hotkeyEnum".
 */
export enum HotkeyEnum {
    OpenIGO = 'OpenIGO',
    OpenPerformanceOverlay = 'OpenPerformanceOverlay',
    OpenChatUI = 'OpenChatUI'
}
/**
 * ShadowPlay Status
 */
export enum ShadowPlayStatus {
    unknown = 'unknown',
    enabled = 'enabled',
    disabled = 'disabled'
}


}
